<script>
  import { User, PawPrint, Stethoscope, ReceiptText, UserCircle, PillBottle, Info } from 'lucide-svelte'

  let { type, ...restProps } = $props()

  let Icon = $derived.by(() => {
    switch (type) {
    case 'Client':
      return UserCircle
    case 'Animal':
      return PawPrint
    case 'Produit':
      return PillBottle
    case 'Acte':
      return Stethoscope
    case 'Facture':
      return ReceiptText
    case 'Utilisateur':
      return User
    default:
      return Info
    }
  })

</script>

<Icon {...restProps} />